export default __webpack_public_path__ + "static/media/schoolRegistration1.4ab19922.jpg";